$('input[type="file"]').on('change', function () {
    var f = this.files[0];
    var name = f.name;
    console.log($(this).closest('.browse-wrap'));
    $(this).siblings('.browse-wrap').children('span.filename').text(name);
});